// entry.client.js
import createApp from './src/app.js';
import { getBlogPost } from './src/content/blogs';

const { app, router } = createApp();

router.onReady(() => {
  updateMeta(router.currentRoute);

  router.beforeEach((to, from, next) => {
    updateMeta(to);
    next();
  });

  const mountEl = document.getElementById('app');
  const hydrate = mountEl && mountEl.hasChildNodes();
  app.$mount('#app', hydrate);
});

function resolveMeta(route) {
  const meta = { ...(route.meta || {}) };
  if (meta.isBlogPost) {
    const post = getBlogPost(route.params.slug);
    if (post) {
      meta.title = post.metaTitle || post.title;
      meta.description = post.description;
      meta.keywords = post.title;
      meta.link = [{ rel: 'canonical', href: `https://androidwaves.org/blogs/${post.slug}/` }];
    }
  }
  return meta;
}

function updateMeta(route) {
  const meta = resolveMeta(route);
  const defaultDescript = 'Download GB WhatsApp v18.80 APK, the latest version updated in August 2026. Get the newest features, privacy options, and installation guide.';
  const defaultKeyword = 'GB WhatsApp, GB WhatsApp APK download';
  const defaultCanonical = 'https://androidwaves.org/gb-whatsapp-apk/';
  document.title = meta.title || 'GB WhatsApp APK Download v18.80 – Latest Version Aug 2026';
  document.documentElement.lang = meta.locale || 'en';

  setMetaTag('description', meta.description || defaultDescript);
  setMetaTag('og:description', meta.description || defaultDescript);
  setMetaTag('keywords', meta.keywords || defaultKeyword);
  setLinkTag('canonical', meta.link?.find((link) => link.rel === 'canonical')?.href || defaultCanonical);

  if (meta.noindex) {
    setMetaTag('robots', 'noindex');
  } else {
    setMetaTag('robots', 'index,follow');
  }
}

function setMetaTag(name, content) {
  let element = document.querySelector(`meta[name="${name}"]`);
  if (element) {
    element.setAttribute('content', content);
  } else {
    element = document.createElement('meta');
    element.setAttribute('name', name);
    element.setAttribute('content', content);
    document.head.appendChild(element);
  }
}

function setLinkTag(rel, href) {
  let element = document.querySelector(`link[rel="${rel}"]`);
  if (element) {
    element.setAttribute('href', href);
  } else {
    element = document.createElement('link');
    element.setAttribute('rel', rel);
    element.setAttribute('href', href);
    document.head.appendChild(element);
  }
}
